import $ from "jquery"

class Search {
  // 1. describe and create/initiate our object
  constructor() {
    
    this.resultsDiv = $("#search-overlay__results")
    this.openButton = $(".js-search-trigger")
    this.closeButton = $(".search-overlay__close")
    this.searchOverlay = $(".search-overlay")
    this.searchField = $("#search-term")
    this.events()
    this.isOverlayOpen = false
    this.isSpinnerVisible = false
    this.previousValue
    this.typingTimer
  }

  // 2. events
  events() {
    this.openButton.on("click", this.openOverlay.bind(this))
    this.closeButton.on("click", this.closeOverlay.bind(this))
    $(document).on("keydown", this.keyPressDispatcher.bind(this))
    this.searchField.on("keyup", this.typingLogic.bind(this))
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer)

      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html('<div class="spinner-loader"></div>')
          this.isSpinnerVisible = true
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750)
      } else {
        this.resultsDiv.html("")
        this.isSpinnerVisible = false
      }
    }

    this.previousValue = this.searchField.val()
  }

  getResults() {
    $.getJSON(shibliData.root_url + "/wp-json/shawkatjps/v1/search?term=" + this.searchField.val(), results => {
      this.resultsDiv.html(`




      <section class="sec-flex">
      <h6 class="features__mini-title sec-mini-title">Search Me</h6>
      <h2 class="features__title sec-title">Welcome to Live Search</h2>
     
              <div class="features__container responsive-grid">
             
      
              <div class="features__container">
                <div class="features__container--feature">
      <i class="fa-solid fa-search features__container--feature__icon sub-icon"></i>
      <h3 class="features__container--feature__number sub-number">01</h3>
      
      <h4 class="features__container--feature__title sub-title">General Information</h4>
      <h4 class="features__container--feature__desc sec-sub-para">
      ${results.generalInfo.length ? '<ul class="link-list min-list">' : "<p>No general information matches that search.</p>"}
      ${results.generalInfo.map(item => `<li><a href="${item.permalink}">${item.title}</a> ${item.postType == "post" ? `by ${item.authorName}` : ""}</li>`).join("")}
    ${results.generalInfo.length ? "</ul>" : ""}
      </h4>
      </div>	 
                
                     
              </div><!-- features__container-01 -->
      
        
              <div class="features__container">
              <div class="features__container--feature">
    
   
    <i class="fa-solid fa-search features__container--feature__icon sub-icon"></i>
    <h3 class="features__container--feature__number sub-number">02</h3>
    
    <h4 class="features__container--feature__title sub-title">portfolio</h4>
    <h4 class="features__container--feature__desc sec-sub-para">
    ${results.portfolioInfo.length ? '<ul class="link-list min-list">' : "<p>No portfolio information matches that search.</p>"}
    ${results.portfolioInfo
      .map(
        item => `
       <div id="main-2col-twentybyauto" class="event-summary mb-md">
       
         <div id="left-col">
         <a class="" href="${item.permalink}">
         <img class="user-nav__user-photo" src="${item.image}">
         </a>
           
           </div><!-- left-col -->
     
           <div id="right-col">
             <div class="event-summary__content">
               
               <h3 class="event-summary__title heading-tertiary u-margin-bottom-small">
               <a href="${item.permalink}">${item.title}</a>
               </h3>
               <p class="event-summary__text">${item.desc} <a href="${item.permalink}" class="btn-text">Read More &rarr;</a>${item.postType == "post" ? `by ${item.authorName}` : ""}</p>
             </div>               
             
         </div><!-- right-col -->
         
       
       </div><!-- our story event -->
       `
       )
       .join("")}
  
  
    </h4>
    </div>	 
              
                   
            </div><!-- features__container-02 --> 
            
              
            <div class="features__container">
            <div class="features__container--feature">
  
 
  <i class="fa-solid fa-search features__container--feature__icon sub-icon"></i>
  <h3 class="features__container--feature__number sub-number">03</h3>
  
  <h4 class="features__container--feature__title sub-title">program</h4>
  <h4 class="features__container--feature__desc sec-sub-para">
  ${results.programInfo.length ? '<ul class="link-list min-list">' : "<p>No program information matches that search.</p>"}
  ${results.programInfo
    .map(
      item => `
     <div id="main-2col-twentybyauto" class="event-summary mb-md">
     
       <div id="left-col">
       <a class="" href="${item.permalink}">
       <img class="user-nav__user-photo" src="${item.image}">
       </a>
         
         </div><!-- left-col -->
   
         <div id="right-col">
           <div class="event-summary__content">
             
             <h3 class="event-summary__title heading-tertiary u-margin-bottom-small">
             <a href="${item.permalink}">${item.title}</a>
             </h3>
             <p class="event-summary__text">${item.desc} <a href="${item.permalink}" class="btn-text">Read More &rarr;</a>${item.postType == "post" ? `by ${item.authorName}` : ""}</p>
           </div>               
           
       </div><!-- right-col -->
       
     
     </div><!-- our story event -->
     `
     )
     .join("")}


  </h4>
  </div>	 
            
                 
          </div><!-- features__container-03 -->          

       
          <div class="features__container">
          <div class="features__container--feature">


<i class="fa-solid fa-search features__container--feature__icon sub-icon"></i>
<h3 class="features__container--feature__number sub-number">04</h3>

<h4 class="features__container--feature__title sub-title">professor</h4>
<h4 class="features__container--feature__desc sec-sub-para">
${results.professorInfo.length ? '<ul class="link-list min-list">' : "<p>No professor information matches that search.</p>"}
${results.professorInfo
  .map(
    item => `
   <div id="main-2col-twentybyauto" class="event-summary mb-md">
   
     <div id="left-col">
     <a class="" href="${item.permalink}">
     <img class="user-nav__user-photo" src="${item.image}">
     </a>
       
       </div><!-- left-col -->
 
       <div id="right-col">
         <div class="event-summary__content">
           
           <h3 class="event-summary__title heading-tertiary u-margin-bottom-small">
           <a href="${item.permalink}">${item.title}</a>
           </h3>
           <p class="event-summary__text">${item.desc} <a href="${item.permalink}" class="btn-text">Read More &rarr;</a>${item.postType == "post" ? `by ${item.authorName}` : ""}</p>
         </div>               
         
     </div><!-- right-col -->
     
   
   </div><!-- our story event -->
   `
   )
   .join("")}


</h4>
</div>	 
          
               
        </div><!-- features__container-04 -->      
        
    
        <div class="features__container">
        <div class="features__container--feature">


<i class="fa-solid fa-search features__container--feature__icon sub-icon"></i>
<h3 class="features__container--feature__number sub-number">05</h3>

<h4 class="features__container--feature__title sub-title">event</h4>
<h4 class="features__container--feature__desc sec-sub-para">
${results.eventInfo.length ? '<ul class="link-list min-list">' : "<p>No event information matches that search.</p>"}
${results.eventInfo
.map(
  item => `
 <div id="main-2col-twentybyauto" class="event-summary mb-md">
 
   <div id="left-col">
   <a class="" href="${item.permalink}">
   <img class="user-nav__user-photo" src="${item.image}">
   </a>
     
     </div><!-- left-col -->

     <div id="right-col">
       <div class="event-summary__content">
         
         <h3 class="event-summary__title heading-tertiary u-margin-bottom-small">
         <a href="${item.permalink}">${item.title}</a>
         </h3>
         <p class="event-summary__text">${item.desc} <a href="${item.permalink}" class="btn-text">Read More &rarr;</a>${item.postType == "post" ? `by ${item.authorName}` : ""}</p>
       </div>               
       
   </div><!-- right-col -->
   
 
 </div><!-- our story event -->
 `
 )
 .join("")}


</h4>
</div>	 
        
             
      </div><!-- features__container-05 -->                

  
      <div class="features__container">
      <div class="features__container--feature">


<i class="fa-solid fa-search features__container--feature__icon sub-icon"></i>
<h3 class="features__container--feature__number sub-number">06</h3>

<h4 class="features__container--feature__title sub-title">smartcricket</h4>
<h4 class="features__container--feature__desc sec-sub-para">
${results.smartcricketInfo.length ? '<ul class="link-list min-list">' : "<p>No smartcricket information matches that search.</p>"}
${results.smartcricketInfo
.map(
item => `
<div id="main-2col-twentybyauto" class="event-summary mb-md">

 <div id="left-col">
 <a class="" href="${item.permalink}">
 <img class="user-nav__user-photo" src="${item.image}">
 </a>
   
   </div><!-- left-col -->

   <div id="right-col">
     <div class="event-summary__content">
       
       <h3 class="event-summary__title heading-tertiary u-margin-bottom-small">
       <a href="${item.permalink}">${item.title}</a>
       </h3>
       <p class="event-summary__text">${item.desc} <a href="${item.permalink}" class="btn-text">Read More &rarr;</a>${item.postType == "post" ? `by ${item.authorName}` : ""}</p>
     </div>               
     
 </div><!-- right-col -->
 

</div><!-- our story event -->
`
)
.join("")}


</h4>
</div>	 
      
           
    </div><!-- features__container-06 -->          
            
            <div class="features__container">
            <div class="features__container--feature">
  
 
  <i class="fa-solid fa-search features__container--feature__icon sub-icon"></i>
  <h3 class="features__container--feature__number sub-number">03</h3>
  
  <h4 class="features__container--feature__title sub-title">Top Deals</h4>
  <h4 class="features__container--feature__desc sec-sub-para">
  ${results.topdealInfo.length ? '<ul class="link-list min-list">' : "<p>No topdeal information matches that search.</p>"}
  ${results.topdealInfo
    .map(
      item => `
     <div id="main-2col-twentybyauto" class="event-summary mb-md">
     
       <div id="left-col">
       <a class="" href="${item.permalink}">
       <img class="user-nav__user-photo" src="${item.image}">
       </a>
         
         </div><!-- left-col -->
   
         <div id="right-col">
           <div class="event-summary__content">
             
             <h3 class="event-summary__title heading-tertiary u-margin-bottom-small">
             <a href="${item.permalink}">${item.title}</a>
             </h3>
             <p class="event-summary__text">${item.desc} <a href="${item.permalink}" class="btn-text">Read More &rarr;</a>${item.postType == "post" ? `by ${item.authorName}` : ""}</p>
           </div>               
           
       </div><!-- right-col -->
       
     
     </div><!-- our story event -->
     `
     )
     .join("")}


  </h4>
  </div>	 
            
                 
          </div><!-- features__container-03 -->            



            </div><!-- features__container responsive-grid -->
            </section><!-- features overall-layout padd sec-flex -->












      `)
      this.isSpinnerVisible = false
    })
  }

  keyPressDispatcher(e) {
    if (e.keyCode == 83 && !this.isOverlayOpen && !$("input, textarea").is(":focus")) {
      this.openOverlay()
    }

    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay()
    }
  }

  openOverlay() {
    this.searchOverlay.addClass("search-overlay--active")
    $("body").addClass("body-no-scroll")
    this.searchField.val("")
    setTimeout(() => this.searchField.focus(), 301)
    console.log("our open method just ran!")
    this.isOverlayOpen = true
  }

  closeOverlay() {
    this.searchOverlay.removeClass("search-overlay--active")
    $("body").removeClass("body-no-scroll")
    console.log("our close method just ran!")
    this.isOverlayOpen = false
  }

 
}

export default Search
